import { ECurrencyCode, EInstrumentCategory, ELanguage, EManagementType } from './common.model';

export interface IUserState {
  loggedUser: ILoggedUser | null;
  isIdle: boolean;
  lastActive: string | null;
  contractsStats: IUserContractsStats | null;
  investmentProfile: IInvestmentProfile | null;
}

export interface IClientCollaboratorOut {
  collaboratorId: number,
  email: string,
  name: IColName,
  phone: IColPhone,
  hasPhoto?: boolean,
}

export enum EContractsComposition {
  BOTH_MIXED = 1, BOTH_NON_DIP, SINGLE_DIP, SINGLE_NON_DIP, NO_CONTRACT
}

export interface IUserContractsStats {
  contracts: IFrameworkContractOut[];
  contractsComposition: EContractsComposition;
}

interface IColName {
  firstName: string,
  lastName: string,
  titleBefore: string,
  titleAfter: string,
}

interface IColPhone {
  prefix: string,
  number: string,
}

export interface IFrameworkContractOut {
  frameworkContractId: number,
  frameworkContractNumber: string,
  dip: boolean,
  inLiquidation: boolean,
  unsignedAdditions: IUnsignedAddition[],
  invSignDate: string, // ex. '2023-05-25'
  opfFeeImplementation: boolean,
}

export interface IUnsignedAddition {
  frameworkContractAdditionId: number,
  type: 'MN_415'
}

export enum EAppearanceMode {
  LIGHT = 'LIGHT', DARK = 'DARK', SYSTEM = 'SYSTEM'
}

export interface ILoggedUser {
  currencyCode: ECurrencyCode,
  clientAccountId: number,
  maxRiskScore: number,
  canReadEnglish: boolean,
  createdDate: string, // ex. "2023-05-25"
  managementType: EManagementType,
  language: ELanguage,
  validContracts: IFrameworkContractOut[],
  hasOpenOrder: boolean,
  personalId: string,
  name: string,
  surname: string,
  firstNameVocative: string;
  addresses: IApiAddressOut[],
  phoneNumber?: string,
  email?: string,
  disclaimerShownAt: string | null,
  instrumentCategories: EInstrumentCategory[],
  appearanceMode: EAppearanceMode,
  aiAnalysisAllowed: boolean,
}

export interface IApiClientAccountOut {
  clientAccountId: number,
  titleBefore: string | null,
  firstName: string,
  lastName: string,
  firstNameVocative: string,
  titleAfter: string | null,
  birthDate: string,
  personalIdentificationNumber: string,
  citizenShipCode: string,
  phoneNumber?: string,
  maxRiskScore: number,
  email?: string,
  addresses: IApiAddressOut[],
  currencyCode: string,
  canReadEnglish: boolean,
  createdDate: string, //ex. '2023-05-25'
  managementType: EManagementType,
  hasOpenOrder: boolean,
  bcasClientId: string,
  validContracts: IFrameworkContractOut[],
  investmentQuestionnaire: IInvestmentQuestionnaire,
  disclaimerShownAt: string | null,
  appearanceMode: EAppearanceMode,
  aiAnalysisAllowed: boolean,
}

interface IInvestmentQuestionnaire {
  date: string
  validityDate: string
  cooldownDate: string
  expired: boolean
  updatable: boolean
  instrumentCategories: EInstrumentCategory[],
}

export interface IApiAddressOut {
  type: 'DOMICILE' | 'POSTAL' | 'ORIGIN',
  streetName: string,
  descriptionNo: string,
  orientationNo: string | null,
  city: string,
  zip: string,
  countryCode: string,
}

export interface IClientCollaboratorOut {
  collaboratorId: number,
  email: string,
  name: IColName,
  phone: IColPhone,
  hasPhoto?: boolean,
}

interface IColName {
  firstName: string,
  lastName: string,
  titleBefore: string,
  titleAfter: string,
}

interface IColPhone {
  prefix: string,
  number: string,
}

export interface IApiInvestmentProfileOut {
  date: string,
  validityDate: string,
  cooldownDate: string,
  expired: boolean,
  updatable: boolean,
  managementType: 'EXECUTION_ONLY' | 'PORTFOLIO_MANAGEMENT',
  instrumentCategories: EInstrumentCategory[],
}

export type IInvestmentProfile = IApiInvestmentProfileOut;

export interface IClientAccountPersonalInformationOut {
  clientAccountId: number,
  titleBefore: string | null,
  firstName: string,
  lastName: string,
  titleAfter: string | null,
  birthDate: string | null,
  citizenShipCode: string | null,
  phoneNumber: string | null,
  email: string
  domicileAddress?: IApiAddressOut | null,
}
